export class MoveInstallationInFolderReqData {
    installationNames: string[] = null;
    folderId: number;

    constructor(installationNames: string[], folderId: number) {
        this.installationNames = installationNames;
        this.folderId = folderId;
    }
}
